import { Badge, Group, Text, Timeline } from '@mantine/core'
import { jobApplicationStatusColor } from '../lib/jobApplicationStatusColors'

// #1127 admin 応募詳細の遷移履歴(job_application_status_changes を時系列)。
// 行データは Rails 側で組み立てて props で受け取る。note(内部メモ)は admin 専用画面なので表示する。
export default function AdminJobApplicationHistory({ rows = [] }) {
  if (rows.length === 0) {
    return <Text c="dimmed" fz="sm">履歴はありません。</Text>
  }

  return (
    <Timeline active={rows.length - 1} bulletSize={18} lineWidth={2}>
      {rows.map((row) => (
        <Timeline.Item
          key={row.id}
          title={
            <Group gap="xs" wrap="wrap">
              {row.fromLabel ? (
                <>
                  <Badge color={jobApplicationStatusColor(row.fromStatus)} variant="light" radius="sm">
                    {row.fromLabel}
                  </Badge>
                  <Text fz="sm" c="dimmed" span>→</Text>
                </>
              ) : (
                <Text fz="sm" c="dimmed" span>応募</Text>
              )}
              <Badge color={jobApplicationStatusColor(row.toStatus)} variant="light" radius="sm">
                {row.toLabel}
              </Badge>
            </Group>
          }
        >
          <Text fz="sm" c="dimmed" mt={4}>
            {row.changedAt} / {row.actorLabel}
          </Text>
          {row.note && (
            <Text fz="sm" mt={6} style={{ whiteSpace: 'pre-wrap' }}>
              {row.note}
            </Text>
          )}
        </Timeline.Item>
      ))}
    </Timeline>
  )
}
